import './App.css';
import '@utils/utilities.css';
import './shared/lib/utils/css/styles.css';
import Routing from './routers/Routing';
import { useAutoVersionCheck } from '@qler-view/shared_lib/src/shared/lib/custom-hooks/useAutoVersionCheck';

export default function App() {
  useAutoVersionCheck();
  return <Routing />;
}
